'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _memoize = require('react-utils/memoize');

var _memoize2 = _interopRequireDefault(_memoize);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _sizes = require('HubStyleTokens/sizes');

var _tshirtSize = require('../utils/propTypes/tshirtSize');

var _Styles = require('../utils/Styles');

var _UIDialogButton = require('../dialog/UIDialogButton');

var _UIDialogButton2 = _interopRequireDefault(_UIDialogButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var SIZE_OPTIONS = {
  sm: {
    size: _sizes.SMALL_CLOSE_BUTTON_SIZE,
    padding: 12
  },
  md: {
    size: _sizes.MEDIUM_CLOSE_BUTTON_SIZE,
    padding: 16
  },
  lg: {
    size: _sizes.MODAL_CLOSE_BUTTON_SIZE,
    padding: 20
  },
  xl: {
    size: _sizes.EXTRA_LARGE_CLOSE_BUTTON_SIZE,
    padding: 38
  }
};

var CloseButton = (0, _styledComponents2.default)(_UIDialogButton2.default).withConfig({
  displayName: 'UICloseButton__CloseButton'
})(['position:absolute;right:', ';top:', ';width:', ';height:', ';color:', ';&::after{padding:', ';}'], _sizes.MODAL_CLOSE_BUTTON_OFFSET, _sizes.MODAL_CLOSE_BUTTON_OFFSET, function (_ref) {
  var size = _ref.size;
  return (0, _Styles.toPx)(size);
}, function (_ref2) {
  var size = _ref2.size;
  return (0, _Styles.toPx)(size);
}, function (_ref3) {
  var color = _ref3.color;
  return color;
}, function (_ref4) {
  var padding = _ref4.padding;
  return (0, _Styles.toPx)(padding);
});

var CloseIcon = _styledComponents2.default.svg.withConfig({
  displayName: 'UICloseButton__CloseIcon'
})(['color:inherit;display:block;flex-grow:1;']);

var CloseIconInner = _styledComponents2.default.path.withConfig({
  displayName: 'UICloseButton__CloseIconInner'
})(['fill:currentColor;stroke:currentColor;stroke-width:2;']);

var renderCloseIcon = (0, _memoize2.default)(function () {
  return _react2.default.createElement(
    CloseIcon,
    { viewBox: '0 0 14 14', xmlns: 'http://www.w3.org/2000/svg' },
    _react2.default.createElement(CloseIconInner, {
      d: 'M14.5,1.5l-13,13m0-13,13,13',
      transform: 'translate(-1 -1)'
    })
  );
});

var UICloseButton = function UICloseButton(_ref5) {
  var className = _ref5.className,
      disabled = _ref5.disabled,
      size = _ref5.size,
      rest = _objectWithoutProperties(_ref5, ['className', 'disabled', 'size']);

  var sizeOptions = SIZE_OPTIONS[(0, _tshirtSize.toShorthandSize)(size)];

  return _react2.default.createElement(CloseButton, _extends({}, rest, {
    'aria-label': _I18n2.default.text('salesUI.UICloseButton.label'),
    className: (0, _classnames2.default)('private-close__button', className),
    'data-action': 'close',
    disabled: disabled,
    IconHolder: renderCloseIcon,
    padding: sizeOptions.padding,
    size: sizeOptions.size
  }));
};

UICloseButton.propTypes = {
  color: _propTypes2.default.string,
  disabled: _propTypes2.default.bool.isRequired,
  size: (0, _tshirtSize.propTypeForSizes)(['sm', 'md', 'lg', 'xl'])
};

UICloseButton.defaultProps = {
  disabled: false,
  size: 'lg'
};

UICloseButton.displayName = 'UICloseButton';

exports.default = UICloseButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/button/UICloseButton.js
// module id = 116
// module chunks = 177